import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { createListStore } from "../../common/listStore";
import { useState } from "react";
import { CustomerDto, ReturnDto } from "./types";
import { renderClose, useDialog } from "../../common/dialog";
import { ReturnDialog } from "./ReturnDialog";
import { UserTypeId, useAccountStore } from "../../common/account";
import { Add } from "@mui/icons-material";
import { UseEntityStore } from "../../common/entityStore";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";

export function ReturnListDialog(props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
}) {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [useReturnListStore] = useState(() => createListStore<ReturnDto>({
        path: "customers/returns?customerId=" + customer.id, listProps: [
            { column: "invcId", label: "Invoice number", width: 120 },
            { column: "retDte", label: "Return date", width: 120, type: "date" },
            { column: "retAmt", label: "Return amount", width: 120, type: "currency" },
            { column: "isBat", label: "Batch", flex: 1, type: "bool" },
        ]
    }));

    const newReturnDialog = useDialog(close => <ReturnDialog close={close} useCustomerStore={props.useCustomerStore} onReturnCreated={() => {
        useReturnListStore.getState().fetch();
        props.useCustomerStore.getState().fetchServerData();
    }} />, "md");
    const accountStore = useAccountStore(p => ({ userTypeId: p.data?.accessTokenDecoded.userTypeId }));

    return <>
        {newReturnDialog.render()}
        <DialogTitle>{customerDialogTitle("Returns", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            {renderListStore(useReturnListStore, {
                header: listHeaderItems([
                    accountStore.userTypeId !== UserTypeId.View && accountStore.userTypeId !== UserTypeId.CollectionAgency && ["new", () => <Button title="New return"
                        onClick={() => newReturnDialog.show()}><Add /></Button>]
                ]),
            })}
        </DialogContent>
        <DialogActions>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
}
